/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Server_Soreness_BodyInputs */

const en_us2_push_server_soreness_body = /** @type {(inputs: Push_Server_Soreness_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are you feeling today? It takes ten seconds.`)
};

const pt_br2_push_server_soreness_body = /** @type {(inputs: Push_Server_Soreness_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como você está se sentindo hoje? Leva dez segundos.`)
};

const es_419_push_server_soreness_body = /** @type {(inputs: Push_Server_Soreness_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo te sientes hoy? Toma diez segundos.`)
};

const pt_pt2_push_server_soreness_body = /** @type {(inputs: Push_Server_Soreness_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como te sentes hoje? Demora dez segundos.`)
};

const fr_fr2_push_server_soreness_body = /** @type {(inputs: Push_Server_Soreness_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment te sens-tu aujourd'hui ? Ça prend dix secondes.`)
};

const de_de2_push_server_soreness_body = /** @type {(inputs: Push_Server_Soreness_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie fühlst du dich heute? Dauert zehn Sekunden.`)
};

const it_it2_push_server_soreness_body = /** @type {(inputs: Push_Server_Soreness_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come ti senti oggi? Ci vogliono dieci secondi.`)
};

/**
* | output |
* | --- |
* | "How are you feeling today? It takes ten seconds." |
*
* @param {Push_Server_Soreness_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_server_soreness_body = /** @type {((inputs?: Push_Server_Soreness_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Server_Soreness_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_server_soreness_body(inputs)
	if (locale === "es-419") return es_419_push_server_soreness_body(inputs)
	if (locale === "pt-PT") return pt_pt2_push_server_soreness_body(inputs)
	if (locale === "fr-FR") return fr_fr2_push_server_soreness_body(inputs)
	if (locale === "de-DE") return de_de2_push_server_soreness_body(inputs)
	if (locale === "it-IT") return it_it2_push_server_soreness_body(inputs)
	return en_us2_push_server_soreness_body(inputs)
});
export { push_server_soreness_body as "push-server.soreness_body" }